import { Routes } from '@angular/router';
import { HomeComponent } from './layout/home/home';
import { LayoutBaseComponent } from './layout/layoutBase/layoutBase';
import { CatalogoBaseComponent } from './features/catalogo/catalogo-base/catalogo-base-component';
import { ProductDetailPageComponent } from './features/product-addon/product-detail-page.component';
import { CheckoutStepperComponent } from './features/checkOut/checkout-stepper.component';
import { LoginPageComponent } from './features/auth/login-page.component';
import { AdminLayoutComponent } from './features/admin/admin-layout.component';
import { AdminProductosComponent } from './features/admin/admin-productos.component';
import { AdminProductoFormComponent } from './features/admin/admin-producto-form.component';
import { AdminCategoriasComponent } from './features/admin/admin-categorias.component';
import { AdminEmpresaComponent } from './features/admin/admin-empresa.component';
import { AdminTallerComponent } from './features/admin/admin-taller.component';
import { AdminPagosComponent } from './features/admin/admin-pagos.component';
import { AdminCapacidadComponent } from './features/admin/admin-capacidad.component';
import { AdminPedidosComponent } from './features/admin/admin-pedidos.component';
import { AdminVerificarComponent } from './features/admin/admin-verificar.component';
import { AdminVerificadosComponent } from './features/admin/admin-verificados.component';
import { AdminEntregasComponent } from './features/admin/admin-entregas.component';
import { AdminZonasComponent } from './features/admin/admin-zonas.component';
import { AdminUsuariosComponent } from './features/admin/admin-usuarios.component';
import { SeguimientoComponent } from './features/seguimiento/seguimiento.component';
import { MisPedidosComponent } from './features/mis-pedidos/mis-pedidos.component';
import { adminGuard, authGuard, menuGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: 'auth/login',
        component: LoginPageComponent
    },
    {
        path: 'auth/register',
        component: LoginPageComponent
    },
    {
        path: 'admin',
        component: AdminLayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'productos', pathMatch: 'full' },
            { path: 'productos', component: AdminProductosComponent, canActivate: [menuGuard('PRODUCTOS')] },
            { path: 'productos/:uuid', component: AdminProductoFormComponent, canActivate: [menuGuard('PRODUCTOS')] },
            { path: 'categorias', component: AdminCategoriasComponent, canActivate: [menuGuard('CATEGORIAS')] },
            { path: 'empresa', component: AdminEmpresaComponent, canActivate: [menuGuard('EMPRESA')] },
            { path: 'taller', component: AdminTallerComponent, canActivate: [menuGuard('TALLER')] },
            { path: 'pagos', component: AdminPagosComponent, canActivate: [menuGuard('PAGOS')] },
            { path: 'capacidad', component: AdminCapacidadComponent, canActivate: [menuGuard('CAPACIDAD')] },
            { path: 'zonas', component: AdminZonasComponent, canActivate: [menuGuard('ZONAS')] },
            { path: 'pedidos', component: AdminPedidosComponent, canActivate: [menuGuard('PEDIDOS')] },
            { path: 'pedidos/verificar', component: AdminVerificarComponent, canActivate: [menuGuard('PEDIDOS')] },
            { path: 'pedidos/verificados', component: AdminVerificadosComponent, canActivate: [menuGuard('PEDIDOS')] },
            { path: 'pedidos/entregas', component: AdminEntregasComponent, canActivate: [menuGuard('PEDIDOS')] },
            { path: 'usuarios', component: AdminUsuariosComponent, canActivate: [adminGuard] }
        ]
    },
    {
        path: '',
        component: LayoutBaseComponent,
        children: [
            { path: '', component: HomeComponent },
            { path: 'catalogo', component: CatalogoBaseComponent },
            { path: 'catalogo/:id', component: CatalogoBaseComponent },
            { path: 'producto/:id', component: ProductDetailPageComponent },
            { path: 'flores', redirectTo: 'catalogo', pathMatch: 'full' },
            { path: 'rosa-roja', redirectTo: 'catalogo', pathMatch: 'full' },
            { path: 'finalizar-compra', component: CheckoutStepperComponent },
            { path: 'seguimiento', component: SeguimientoComponent },
            {
                path: 'mis-pedidos',
                component: MisPedidosComponent,
                canActivate: [authGuard]
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
